import { Stack } from '@mui/material';
import RecommendationActions from '/@/components/recommendation-create/bayer/actions';
import RecommendationLockup from '/@/components/recommendation-create/bayer/lockup';
import RecommendationDesktopSidebar from '/@/components/recommendation-create/bayer/sidebar/desktop';
import RecommendationMobileSidebar from '/@/components/recommendation-create/bayer/sidebar/mobile';
import Spinner from '/@/components/spinner';
import type { Step } from '/@/types/recommendation-create';
import useWindowSize from '/@/utils/hooks/window-size';

function RecommendationCreate({
    steps,
    activeStep,
    setActiveStep,
    isLoading,
    areActionsLoading,
    height,
}: {
    steps: Step[];
    activeStep: number;
    setActiveStep: (activeStep: number) => void;
    isLoading?: boolean;
    areActionsLoading?: boolean;
    height?: string;
}) {
    const isMobile = useWindowSize().width <= 900;
    const controlledSetActiveStep = (stepIndex: number) => {
        if (activeStep > stepIndex) {
            setActiveStep(stepIndex);
        }
    };
    if (isLoading) {
        return (
            <Stack height='100%' alignItems='center' justifyContent='center'>
                <Spinner />
            </Stack>
        );
    }
    return (
        <Stack height={height || '100%'} position='relative'>
            <Stack direction={isMobile ? 'column' : 'row'} flexGrow={1} overflow='hidden' sx={{ mb: '85px' }}>
                {isMobile ? (
                    <RecommendationMobileSidebar
                        steps={steps}
                        activeStep={activeStep}
                        setActiveStep={controlledSetActiveStep}
                    />
                ) : (
                    <Stack>
                        <RecommendationDesktopSidebar
                            steps={steps}
                            activeStep={activeStep}
                            setActiveStep={controlledSetActiveStep}
                        />
                    </Stack>
                )}
                <Stack px={isMobile ? 3 : 10} overflow='scroll' flexGrow={1}>
                    {steps[activeStep] && (
                        <RecommendationLockup
                            recommendationType={steps[activeStep].recommendationType || ''}
                            title={steps[activeStep].title || ''}
                            subtitle={steps[activeStep].subtitle || ''}
                        />
                    )}
                    {steps[activeStep]?.content}
                </Stack>
            </Stack>
            <RecommendationActions
                steps={steps}
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                isLoading={areActionsLoading}
            />
        </Stack>
    );
}

export default RecommendationCreate;
